import { render, staticRenderFns } from "./TreatmentOfferEmailTemplate.vue?vue&type=template&id=96dee5f4&scoped=true"
import script from "./TreatmentOfferEmailTemplate.vue?vue&type=script&lang=js"
export * from "./TreatmentOfferEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./TreatmentOfferEmailTemplate.vue?vue&type=style&index=0&id=96dee5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dee5f4",
  null
  
)

export default component.exports